export const mockHeader = "x-fetch-client-mock";

export const loadForeverType = "loadForever";

export function loadForeverPromise() {
    return new Promise<Response>(() => {});
}
